module.exports = __webpack_public_path__ + "img/menubar_footer_img.fec074aa.svg";